<template>
  <div>
    <b-card no-body>
      <b-card-header>
          <h3 class="float-left"><i class='fa fa-globe'></i> Domain</h3>
          <!-- <b-button variant="primary" class="float-right" @click="showCreateModal">Create Domain</b-button> -->
      </b-card-header>
      <b-card-body>
        <div class="overflow-auto">
          <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
            <template v-slot:cell(RoutineRedeem)="data">
              <b-badge v-if="data.item.RoutineRedeem === 0" variant="danger">Disabled</b-badge>
              <b-badge v-else-if="data.item.RoutineRedeem === 1" variant="success">Enabled</b-badge>
            </template>
            <template v-slot:cell(action)="data">
              <b-button variant="warning" @click="editDomain(data.item)">Edit</b-button>
            </template>
          </b-table>
        </div>
        <nav>
          <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
    </b-card>
    <b-modal ref="editDomain" size="lg" header-bg-variant="primary" hide-footer title="Edit Domain">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.domainCode.$error && $v.domainGameUrl.$error && $v.domainSkin.$error && $v.domainRedeemUrl.$error && $v.domainEndSessionUrl.$error)">
                      <b-row>
                        <b-col sm="6">
                          <label for="domainCode">Code</label>
                          <b-form-input type="text" readonly id="domainCode" placeholder="Domain Code" v-model.trim="domainCode" :state="$v.domainCode.$error?false:null" @focus.native="$v.domainCode.$touch"></b-form-input>
                          <div v-if="$v.domainCode.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainCode.required">Code is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainCode.minLength">Must have at least {{ $v.domainCode.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainCode.maxLength">Must not exceed {{ $v.domainCode.$params.maxLength.max}} letters</div>
                          </div>
                        </b-col>
                        <b-col sm="6">
                          <label for="domainSkin">Skin</label>
                          <b-form-input type="text" id="domainSkin" placeholder="Game Skin" v-model.trim="domainSkin" :state="$v.domainSkin.$error?false:null" @focus.native="$v.domainSkin.$touch"></b-form-input>
                          <div v-if="$v.domainSkin.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainSkin.required">Game skin is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainSkin.minLength">Must have at least {{ $v.domainSkin.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainSkin.maxLength">Must not exceed {{ $v.domainSkin.$params.maxLength.max}} letters</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12">
                          <label for="domainGameUrl">Game URL</label>
                          <b-form-input type="text" id="domainGameUrl" placeholder="Game URL" v-model.trim="domainGameUrl" :state="$v.domainGameUrl.$error?false:null" @focus.native="$v.domainGameUrl.$touch"></b-form-input>
                          <div v-if="$v.domainGameUrl.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainGameUrl.required">Game url is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainGameUrl.minLength">Must have at least {{ $v.domainGameUrl.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainGameUrl.maxLength">Must not exceed {{ $v.domainGameUrl.$params.maxLength.max}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainGameUrl.url">Must be valid url format</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12">
                          <label for="domainRedeemUrl">Redeem URL</label>
                          <b-form-input type="text" id="domainRedeemUrl" placeholder="Redeem URL" v-model.trim="domainRedeemUrl" :state="$v.domainRedeemUrl.$error?false:null" @focus.native="$v.domainRedeemUrl.$touch"></b-form-input>
                          <div v-if="$v.domainRedeemUrl.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainRedeemUrl.required">Redeem url is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainRedeemUrl.minLength">Must have at least {{ $v.domainRedeemUrl.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainRedeemUrl.maxLength">Must not exceed {{ $v.domainRedeemUrl.$params.maxLength.max}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainRedeemUrl.url">Must be valid url format</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12">
                          <label for="domainRedeemBotUrl">Redeem Bot URL</label>
                          <b-form-input type="text" id="domainRedeemBotUrl" placeholder="Redeem URL" v-model.trim="domainRedeemBotUrl" :state="$v.domainRedeemBotUrl.$error?false:null" @focus.native="$v.domainRedeemBotUrl.$touch"></b-form-input>
                          <div v-if="$v.domainRedeemBotUrl.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainRedeemBotUrl.minLength">Must have at least {{ $v.domainRedeemBotUrl.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainRedeemBotUrl.maxLength">Must not exceed {{ $v.domainRedeemBotUrl.$params.maxLength.max}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainRedeemBotUrl.url">Must be valid url format</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12">
                          <label for="domainEndSessionUrl">End Session URL</label>
                          <b-form-input type="text" id="domainEndSessionUrl" placeholder="End Session URL" v-model.trim="domainEndSessionUrl" :state="$v.domainEndSessionUrl.$error?false:null" @focus.native="$v.domainEndSessionUrl.$touch"></b-form-input>
                          <div v-if="$v.domainEndSessionUrl.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainEndSessionUrl.required">Redeem url is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainEndSessionUrl.minLength">Must have at least {{ $v.domainEndSessionUrl.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainEndSessionUrl.maxLength">Must not exceed {{ $v.domainEndSessionUrl.$params.maxLength.max}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainEndSessionUrl.url">Must be valid url format</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="6">
                          <label for="domainDrawListId">Draw List</label>
                          <b-form-select id="domainDrawListId" :plain="false" v-model="domainDrawListId">
                            <option :value="null">Please select</option>
                            <option v-for="r in drawLists" :value="r.Id" :key="r.Id">{{ r.Name }}</option>
                          </b-form-select>
                        </b-col>
                        <b-col sm="6">
                          <label for="domainRoutineRedeem">Routine Redeem Status</label>
                          <b-form-select id="domainRoutineRedeem" :plain="false" v-model="domainRoutineRedeem">
                            <option v-for="r in routineRedeemStatusOptions" :value="r.Value" :key="r.Value">{{ r.Label }}</option>
                          </b-form-select>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="updateDomain" :disabled="$v.domainCode.$invalid || $v.domainGameUrl.$invalid || $v.domainSkin.$invalid || $v.domainRedeemUrl.$invalid || $v.domainEndSessionUrl.$invalid">Update</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="closeEdit">Cancel</b-btn>
    </b-modal>
    <!-- <b-modal ref="createDomain" size="lg" header-bg-variant="primary" hide-footer title="Create Domain">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.domainCode.$error && $v.domainGameUrl.$error && $v.domainSkin.$error && $v.domainRedeemUrl.$error && $v.domainEndSessionUrl.$error)">
                      <b-row>
                        <b-col sm="6">
                          <label for="domainCode">Code</label>
                          <b-form-input type="text" id="domainCode" placeholder="Domain Code" v-model.trim="domainCode" :state="$v.domainCode.$error?false:null" @focus.native="$v.domainCode.$touch"></b-form-input>
                          <div v-if="$v.domainCode.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainCode.required">Code is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainCode.minLength">Must have at least {{ $v.domainCode.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainCode.maxLength">Must not exceed {{ $v.domainCode.$params.maxLength.max}} letters</div>
                          </div>
                        </b-col>
                        <b-col sm="6">
                          <label for="domainSkin">Skin</label>
                          <b-form-input type="text" id="domainSkin" placeholder="Game Skin" v-model.trim="domainSkin" :state="$v.domainSkin.$error?false:null" @focus.native="$v.domainSkin.$touch"></b-form-input>
                          <div v-if="$v.domainSkin.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainSkin.required">Game skin is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainSkin.minLength">Must have at least {{ $v.domainSkin.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainSkin.maxLength">Must not exceed {{ $v.domainSkin.$params.maxLength.max}} letters</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12">
                          <label for="domainGameUrl">Game URL</label>
                          <b-form-input type="text" id="domainGameUrl" placeholder="Game URL" v-model.trim="domainGameUrl" :state="$v.domainGameUrl.$error?false:null" @focus.native="$v.domainGameUrl.$touch"></b-form-input>
                          <div v-if="$v.domainGameUrl.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainGameUrl.required">Game url is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainGameUrl.minLength">Must have at least {{ $v.domainGameUrl.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainGameUrl.maxLength">Must not exceed {{ $v.domainGameUrl.$params.maxLength.max}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainGameUrl.url">Must be valid url format</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12">
                          <label for="domainRedeemUrl">Redeem URL</label>
                          <b-form-input type="text" id="domainRedeemUrl" placeholder="Redeem URL" v-model.trim="domainRedeemUrl" :state="$v.domainRedeemUrl.$error?false:null" @focus.native="$v.domainRedeemUrl.$touch"></b-form-input>
                          <div v-if="$v.domainRedeemUrl.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainRedeemUrl.required">Redeem url is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainRedeemUrl.minLength">Must have at least {{ $v.domainRedeemUrl.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainRedeemUrl.maxLength">Must not exceed {{ $v.domainRedeemUrl.$params.maxLength.max}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainRedeemUrl.url">Must be valid url format</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12">
                          <label for="domainRedeemBotUrl">Redeem Bot URL</label>
                          <b-form-input type="text" id="domainRedeemBotUrl" placeholder="Redeem Bot URL" v-model.trim="domainRedeemBotUrl" :state="$v.domainRedeemBotUrl.$error?false:null" @focus.native="$v.domainRedeemBotUrl.$touch"></b-form-input>
                          <div v-if="$v.domainRedeemBotUrl.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainRedeemBotUrl.minLength">Must have at least {{ $v.domainRedeemBotUrl.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainRedeemBotUrl.maxLength">Must not exceed {{ $v.domainRedeemBotUrl.$params.maxLength.max}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainRedeemBotUrl.url">Must be valid url format</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12">
                          <label for="domainEndSessionUrl">End Session URL</label>
                          <b-form-input type="text" id="domainEndSessionUrl" placeholder="End Session URL" v-model.trim="domainEndSessionUrl" :state="$v.domainEndSessionUrl.$error?false:null" @focus.native="$v.domainEndSessionUrl.$touch"></b-form-input>
                          <div v-if="$v.domainEndSessionUrl.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.domainEndSessionUrl.required">Redeem url is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainEndSessionUrl.minLength">Must have at least {{ $v.domainEndSessionUrl.$params.minLength.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainEndSessionUrl.maxLength">Must not exceed {{ $v.domainEndSessionUrl.$params.maxLength.max}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.domainEndSessionUrl.url">Must be valid url format</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="6">
                          <label for="domainDrawListId">Draw List</label>
                          <b-form-select id="domainDrawListId" :plain="false" v-model="domainDrawListId">
                            <option :value="null">Please select</option>
                            <option v-for="r in drawLists" :value="r.Id" :key="r.Id">{{ r.Name }}</option>
                          </b-form-select>
                        </b-col>
                        <b-col sm="6">
                          <label for="domainRoutineRedeem">Routine Redeem Status</label>
                          <b-form-select id="domainRoutineRedeem" :plain="false" v-model="domainRoutineRedeem">
                            <option v-for="r in routineRedeemStatusOptions" :value="r.Value" :key="r.Value">{{ r.Label }}</option>
                          </b-form-select>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="createDomain" :disabled="$v.domainCode.$invalid || $v.domainGameUrl.$invalid || $v.domainSkin.$invalid || $v.domainRedeemUrl.$invalid || $v.domainEndSessionUrl.$invalid">Create</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="hideCreateModal">Cancel</b-btn>
    </b-modal> -->
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  export default {
    name: 'gift-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        drawLists: [],
        routineRedeemStatusOptions: [
          { Label: 'Disabled', Value: 0 },
          { Label: 'Enabled', Value: 1 }
        ],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Code', label: 'Code'},
          {key: 'GameUrl', label: 'Game URL'},
          {key: 'Skin', label: 'Skin'},
          {key: 'RedeemLink', label: 'Redeem URL'},
          {key: 'RedeemBotLink', label: 'Redeem Bot URL'},
          {key: 'EndSessionLink', label: 'End Session URL'},
          {key: 'DrawListName', label: 'Draw List'},
          {key: 'RoutineRedeem', label: 'Routine Redeem Status'},
          {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        perPage: 10,
        domainId: '',
        domainCode: '',
        domainGameUrl: '',
        domainSkin: '',
        domainRedeemUrl: '',
        domainRedeemBotUrl: '',
        domainRoutineRedeem: 0,
        domainEndSessionUrl: '',
        domainDrawListId: null
      }
    },
    validations: {
      domainCode: { required, minLength: minLength(2), maxLength: maxLength(50) },
      domainSkin: { required, minLength: minLength(2), maxLength: maxLength(50) },
      domainGameUrl: { required, minLength: minLength(2), maxLength: maxLength(100) },
      domainRedeemUrl: { required, minLength: minLength(2), maxLength: maxLength(100) },
      domainRedeemBotUrl: { minLength: minLength(2), maxLength: maxLength(100) },
      domainEndSessionUrl: { required, minLength: minLength(2), maxLength: maxLength(100) }
    },
    watch: {
      currentPage: function () {
        this.getDomains()
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      getDomains () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/domain/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.domains
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getDrawLists () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/draw/list/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          console.log(response.data.list)
          this.drawLists = response.data.list
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      updateDomain () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/domain/update',
          {
            'id': this.domainId,
            'code': this.domainCode,
            'gameUrl': this.domainGameUrl,
            'skin': this.domainSkin,
            'redeemUrl': this.domainRedeemUrl,
            'redeemBotUrl': this.domainRedeemBotUrl,
            'routineRedeem': this.domainRoutineRedeem,
            'endSessionUrl': this.domainEndSessionUrl,
            'drawListId': this.domainDrawListId
          },
          {headers: { 'Content-Type': 'application/json' }}
        ).then(response => {
          if (response.status === 200) {
            this.getDomains()
            this.closeEdit()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Domain Updated')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      createDomain () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/domain/add',
          {
            'code': this.domainCode,
            'gameUrl': this.domainGameUrl,
            'skin': this.domainSkin,
            'redeemUrl': this.domainRedeemUrl,
            'redeemBotUrl': this.domainRedeemBotUrl,
            'routineRedeem': this.domainRoutineRedeem,
            'endSessionUrl': this.domainEndSessionUrl,
            'drawListId': this.domainDrawListId
          },
          {headers: { 'Content-Type': 'application/json' }}
        ).then(response => {
          if (response.status === 200) {
            this.getDomains()
            this.hideCreateModal()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Domain Created')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      editDomain (item) {
        this.domainId = item.Id
        this.domainCode = item.Code
        this.domainGameUrl = item.GameUrl
        this.domainSkin = item.Skin
        this.domainRedeemUrl = item.RedeemLink
        this.domainRedeemBotUrl = item.RedeemBotLink
        this.domainRoutineRedeem = item.RoutineRedeem
        this.domainEndSessionUrl = item.EndSessionLink
        this.domainDrawListId = item.DrawListId
        this.$refs.editDomain.show()
      },
      closeEdit () {
        this.$refs.editDomain.hide()
      },
      showCreateModal () {
        this.reset()
        this.$refs.createDomain.show()
      },
      hideCreateModal () {
        this.$refs.createDomain.hide()
      },
      reset () {
        this.domainId = ''
        this.domainCode = ''
        this.domainGameUrl = ''
        this.domainSkin = ''
        this.domainRedeemUrl = ''
        this.domainRedeemBotUrl = ''
        this.domainRoutineRedeem = 0
        this.domainEndSessionUrl = ''
        this.domainDrawListId = null
      }
    },
    created () {
      this.getDomains()
      this.getDrawLists()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/domain/DomainTable.vue